package com.tregz.tremenz.ui.theme

import androidx.compose.runtime.Immutable
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.ui.graphics.Color

/** The active day or night theme, and the toggle a host offers, or null when it keeps one fixed. */
@Immutable
class ThemeSwitch(
    val isNight: Boolean,
    val onToggle: (() -> Unit)?
) {
    /** Toolbar fill: crimson maroon at night, the previous website's nav red by day. */
    val toolbarColor: Color
        get() = toolbarColor(isNight)

    /** Icons and wordmark drawn on [toolbarColor]. */
    val onToolbarColor: Color
        get() = if (isNight) Color.White else TremenzDayOnRedContainer

    /** The wordmark keeps the coral accent at night and turns white on the red day toolbar. */
    val wordmarkColor: Color
        get() = if (isNight) TremenzCoralBright else TremenzDayOnRedContainer
}

/** Hosts tint the browser or system chrome with the same color, so the toolbar fills the window. */
fun toolbarColor(isNight: Boolean): Color = if (isNight) TremenzMaroonCrimson else TremenzDayRedContainer

val LocalThemeSwitch = compositionLocalOf { ThemeSwitch(isNight = true, onToggle = null) }
